/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProductStock200Response
 */
export interface GetProductStock200Response {
    /**
     * 
     * @type {string}
     * @memberof GetProductStock200Response
     */
    refillPolicy: string;
    /**
     * 
     * @type {number}
     * @memberof GetProductStock200Response
     */
    refillValue?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductStock200Response
     */
    stock: number;
}

/**
 * Check if a given object implements the GetProductStock200Response interface.
 */
export function instanceOfGetProductStock200Response(value: object): value is GetProductStock200Response {
    if (!('refillPolicy' in value) || value['refillPolicy'] === undefined) return false;
    if (!('stock' in value) || value['stock'] === undefined) return false;
    return true;
}

export function GetProductStock200ResponseFromJSON(json: any): GetProductStock200Response {
    return GetProductStock200ResponseFromJSONTyped(json, false);
}

export function GetProductStock200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProductStock200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'refillPolicy': json['refillPolicy'],
        'refillValue': json['refillValue'] == null ? undefined : json['refillValue'],
        'stock': json['stock'],
    };
}

export function GetProductStock200ResponseToJSON(json: any): GetProductStock200Response {
    return GetProductStock200ResponseToJSONTyped(json, false);
}

export function GetProductStock200ResponseToJSONTyped(value?: GetProductStock200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refillPolicy': value['refillPolicy'],
        'refillValue': value['refillValue'],
        'stock': value['stock'],
    };
}

